import { BrowserRouter } from 'react-router-dom'
import { FeatureFlagsPrefetch } from '@/core/feature-flags'
import { UserNoticeDeadEnd } from '@/features/user-notice/components/user-notice-dead-end'
import { SmartAppBanner } from '@/shared/components/smart-app-banner'
import { useAppLink } from '@/shared/hooks/use-app-link'
import { AppRoutes } from '@/shared/routing/app-routes'

function AppLinkPrefetch() {
  useAppLink()
  return null
}

export default function App() {
  return (
    <BrowserRouter>
      <AppLinkPrefetch />
      {/* Warms GrowthBook config once authed, so experience gates resolve
          without a flash. */}
      <FeatureFlagsPrefetch />
      <div className="flex h-dvh flex-col">
        <SmartAppBanner />
        <div className="min-h-0 flex-1">
          <AppRoutes />
        </div>
        {/* Outside the route tree on purpose: the routes it has to cover are siblings of
            each other, so no single layout can hold it. Renders nothing until some surface
            has asked and been answered HARD. */}
        <UserNoticeDeadEnd />
      </div>
    </BrowserRouter>
  )
}
